import axios from 'axios';
import { getRecommendationsGTech } from './standalone/g-tech/recommendation';

document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('#g-tech-recommendation--js');
    const isportArticles = document.querySelectorAll("[data-control = 'g-tech-recommendation']");
    const domain = window.location.host;
    const behavUuid = wrapper.getAttribute('data-behav-uuid');
    const articleId = wrapper.getAttribute('data-current-article-id');
    const numberOfArticles = domain.includes('sport')
        ? 5
        : wrapper.getAttribute('data-numb-of-articles');
    const nameForStats = wrapper.getAttribute('data-name-for-stats');

    function eslintConsole(e) {
        console.log(e); //eslint-disable-line
    }

    const abTest = async () => {
        try {
            const options = { user_id: behavUuid, test_id: 'grec-isport' };
            const auth =
                'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJwcmdfY21zIn0.tWgx_m0BnLdA8HdsSTGEYSA3a4sNDeSLOTIeta9wDn0';
            await axios
                .post('https://ab.cncenter.cz/user-test-variant', options, {
                    headers: {
                        Authorization: auth,
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    const abResult = res.data.variant;

                    if (abResult === 'B' || abResult === 'BB') {
                        getRecommendationsGTech(domain, articleId, numberOfArticles, nameForStats);
                    } else {
                        isportArticles.forEach((content) => {
                            content.style.display = 'inline-block';

                            const articles = content.querySelectorAll('article');

                            if (articles.length > 0) {
                                articles.forEach((article) => {
                                    article.dataset.gtechRec = 'A';
                                });
                            }
                        });
                    }
                });
        } catch (e) {
            eslintConsole(e);
        }
    };

    if (behavUuid) {
        abTest();
    } else {
        isportArticles.forEach((content) => {
            content.style.display = 'inline-block';

            const articles = content.querySelectorAll('article');

            if (articles.length > 0) {
                articles.forEach((article) => {
                    article.dataset.gtechRec = 'none';
                });
            }
        });
    }
});
